
<template>
  <div class="yk-breadcrumb">
    当前位置：
    <p class="item" v-for="(item, index) in list" :key="'bread'+index" @click.stop="clickPush(item)">{{item.name}}> </p>
    <p class="item" @click.stop="clickGoBack">{{typeName}}</p>
  </div>
</template>
<script>
export default {
  data () {
    return {
      list: [
        {name: '主页', path: '/home'},
      ]
    }
  },
  props: {
    typeName: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
  },
  mounted () {
    
  },
  components: {},
  methods: {
    clickPush(item){
      this.$router.push(item.path);
    },
    clickGoBack(){
      this.$router.back();
    }
  }
}
</script>
<style scoped lang="stylus">
.yk-breadcrumb
  width $pageWidth
  margin 0 auto
  line-height 44px
  padding 0 20px
  display flex
  font-size 18px
  color $c1
  background-color #F7F7F7
  .item
    margin 0 10px
    &:last-child
      color #04469D
    cursor pointer
</style>
